import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ReactNotifications } from 'react-notifications-component';
import React, { useState } from "react";

import { ClienteContext } from "./components/services/ClienteContext";
import UserLogin from "./components/Views/Login/UserLogin";
import MinecraftServerUI from "./components/Views/Home/MinecraftServerUI";
import 'react-notifications-component/dist/theme.css';
import 'animate.css';
import Header from "./components/Views/Header/Header"


const App = () => {

  const [dados, setDados] = useState({})

  return (
    <ClienteContext.Provider value={{ dados, setDados }}>
      <Router basename="/worldofgus">
        <ReactNotifications id='notification' />
        <Routes >
          <Route path="/" element={<UserLogin />} />
          <Route path="/login" element={<UserLogin />} />
          <Route path="/home" element={<><Header dados={dados} /><MinecraftServerUI /></>} />
        </Routes>
      </Router>
    </ClienteContext.Provider >
  );
}

export default App;
